import { render, staticRenderFns } from "./Integral.vue?vue&type=template&id=2acb515f&scoped=true"
import script from "./Integral.vue?vue&type=script&lang=js"
export * from "./Integral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acb515f",
  null
  
)

export default component.exports